import { render, staticRenderFns } from "./LearnMoreIcon.vue?vue&type=template&id=8c48d294"
import script from "./LearnMoreIcon.vue?vue&type=script&lang=js"
export * from "./LearnMoreIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports